import ComponentName from '../../constant/ComponentName';
import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { UserSocketSession } from '../../service/ComponentService';
import { TenantModuleType } from '../../domain/rbac/RbacDomains';

export type ComponentActions =
  | 'ENTER_COMPONENT'
  | 'LEAVE_COMPONENT'
  | 'CHANGE_WORKERS'
  | 'CHANGE_LOCK'
  | 'SET_SELECTED_COMPONENTS'
  | 'CHANGE_USER_SESSIONS'
  | 'CHANGE_IS_DIRTY'
  | 'ADD_GLOBAL_WORKERS'
  | 'REMOVE_GLOBAL_WORKERS'
  | 'CLEAR_GLOBAL_WORKERS'
  | 'SET_TENANT_MODULE';

export interface ChangeCategoryAction {
  component: ComponentName;
  id: string;
  disablePathCalculation?: boolean;
}

export interface ComponentWorker {
  id: string;
  username: string;
  avatarName: string;
}

export interface ComponentState {
  component: ComponentName | null;
  id: string | null;
  workers: ComponentWorker[];
  globalWorkers: Record<string, { worker: ComponentWorker; componentId: string }[]>;
  lock: ComponentWorker | null;
  selectedComponentIds: any[] | any;
  selfLock: boolean;
  userSessions: UserSocketSession[];
  isDirty: boolean;
  module: TenantModuleType[];
}

export const enterComponent = (payload: ChangeCategoryAction) => {
  return {
    type: 'ENTER_COMPONENT',
    payload,
  } as ReduxBaseAction<ChangeCategoryAction, ComponentActions>;
};

export const leaveComponent = () =>
  ({
    type: 'LEAVE_COMPONENT',
    payload: {},
  }) as ReduxBaseAction<ChangeCategoryAction, ComponentActions>;

export const changeWorkers = (payload: ComponentWorker[]): ReduxBaseAction<any, ComponentActions> => {
  return {
    type: 'CHANGE_WORKERS',
    payload,
  };
};

export const addGlobalWorkers = (payload: {
  worker: ComponentWorker;
  componentId: string;
  component: ComponentName;
}): ReduxBaseAction<any, ComponentActions> => {
  return {
    type: 'ADD_GLOBAL_WORKERS',
    payload,
  };
};

export const removeGlobalWorkers = (payload: { componentId: string; component: ComponentName }): ReduxBaseAction<any, ComponentActions> => {
  return {
    type: 'REMOVE_GLOBAL_WORKERS',
    payload,
  };
};

export const clearGlobalWorkers = (): ReduxBaseAction<void, ComponentActions> => {
  return {
    type: 'CLEAR_GLOBAL_WORKERS',
    payload: void 0,
  };
};

export const changeLock = (payload: ComponentWorker | null): ReduxBaseAction<any, ComponentActions> => {
  return {
    type: 'CHANGE_LOCK',
    payload,
  };
};

export const setSelectedItems = (payload: any[] | undefined): ReduxBaseAction<any, ComponentActions> => {
  return {
    type: 'SET_SELECTED_COMPONENTS',
    payload,
  };
};

export const changeUserSessions = (payload: UserSocketSession): ReduxBaseAction<UserSocketSession, ComponentActions> => {
  return {
    type: 'CHANGE_USER_SESSIONS',
    payload,
  };
};

export const changeIsDirty = (payload: boolean): ReduxBaseAction<boolean, ComponentActions> => {
  return {
    type: 'CHANGE_IS_DIRTY',
    payload,
  };
};

export const setTenantModule = (module: TenantModuleType[]) => ({ type: 'SET_TENANT_MODULE', payload: module });
